/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import React from 'react';
import RadarIcon from "@mui/icons-material/Radar";
import VideocamIcon from "@mui/icons-material/Videocam";
import sidebar_ObjDef from "../containers/images/landing_images/Object_definition.png";
import sidebar_SesOBJ from "../containers/images/landing_images/Vehicle_SensingSystem_logo.png";
import {FaRoad} from 'react-icons/fa';
import LooksIcon from '@mui/icons-material/Looks';
import * as colors from './colors'
import WysiwygIcon from "@mui/icons-material/Wysiwyg";
import SensingSystemArchitectureDesignAppIcon from '@mui/icons-material/Architecture';

import { ReactComponent as LidarSvg } from '../containers/images/sensors/lidar4.svg'
import { ReactComponent as UltrasonicSvg } from '../containers/images/sensors/ultrasonic1.svg'

enum ETrackedItemTypes {
  RADAR_CONFIGURATION = 'Radar',
  CAMERA_CONFIGURATION = 'Camera',
  LIDAR_CONFIGURATION = 'Lidar',
  ULTRASONIC_CONFIGURATION = 'Ultrasonic',

  OBJECT = 'Object',

  POTENTIALLY_MOVING_OBJECTS = 'Potentially Moving Objects',
  MISCELLANEOUS_OBJECTS = 'Miscellaneous Objects',
  RWO_SIGNS = 'Sign Objects',
  OBJECT_CLASSIFICATION = 'Object Classification',
  RWO_SIGNS_PICKLIST = 'Sign Objects - Picklist Data',

  VEHICLE_PROGRAM = 'Vehicle Program',
  VEHICLE_PROGRAM_DEVELOPMENT_STAGE = 'Vehicle Program Development Stage',

  SCENARIO_ANALYSIS = 'Scenario Analysis',
  SENSING_SYSTEM_ARCHITECTURE_DESIGN = 'Sensing System Architecture Design',
  COVERAGE_REQUIREMENTS_DATASET = 'Coverage Requirements Dataset',
  ADAS_PROGRAM = 'ADAS Program',
  UNKNOWN = 'Unknown'
}

const imgColor = colors.baseBlue
const imgStyle = {width: 24, height: 24, color: imgColor}

const TRACKED_ITEMS_ICONS_MAP: any = {
  [ETrackedItemTypes.RADAR_CONFIGURATION]: <RadarIcon style={imgStyle}/>,
  [ETrackedItemTypes.CAMERA_CONFIGURATION]: <VideocamIcon style={imgStyle}/>,
  [ETrackedItemTypes.LIDAR_CONFIGURATION]: <LidarSvg style={imgStyle}/>,
  [ETrackedItemTypes.ULTRASONIC_CONFIGURATION]: <UltrasonicSvg style={imgStyle}/>,

  [ETrackedItemTypes.OBJECT]: <img src={sidebar_ObjDef} style={imgStyle}/>,

  [ETrackedItemTypes.POTENTIALLY_MOVING_OBJECTS]: <img src={sidebar_ObjDef} style={imgStyle}/>,
  [ETrackedItemTypes.MISCELLANEOUS_OBJECTS]: <img src={sidebar_ObjDef} style={imgStyle}/>,
  [ETrackedItemTypes.RWO_SIGNS]: <img src={sidebar_ObjDef} style={imgStyle}/>,
  [ETrackedItemTypes.OBJECT_CLASSIFICATION]: <img src={sidebar_ObjDef} style={imgStyle}/>,
  [ETrackedItemTypes.RWO_SIGNS_PICKLIST]: <img src={sidebar_ObjDef} style={imgStyle}/>,

  [ETrackedItemTypes.VEHICLE_PROGRAM]: <img src={sidebar_SesOBJ} style={imgStyle}/>,
  [ETrackedItemTypes.VEHICLE_PROGRAM_DEVELOPMENT_STAGE]: <img src={sidebar_SesOBJ} style={imgStyle}/>,

  [ETrackedItemTypes.SCENARIO_ANALYSIS]: <FaRoad style={imgStyle}/>,
  [ETrackedItemTypes.SENSING_SYSTEM_ARCHITECTURE_DESIGN]: <SensingSystemArchitectureDesignAppIcon style={imgStyle}/>,
  [ETrackedItemTypes.COVERAGE_REQUIREMENTS_DATASET]: <LooksIcon style={imgStyle}/>,
  [ETrackedItemTypes.ADAS_PROGRAM]: <WysiwygIcon style={imgStyle}/>,
  [ETrackedItemTypes.UNKNOWN]: null
}

export {
  ETrackedItemTypes,
  TRACKED_ITEMS_ICONS_MAP
}